import { createErrorMessage } from '@hooks/mqtt/utils';
import { atom } from 'jotai';
import {
  activeTopicsAtom,
  subscriptionConfigAtomFamily,
  topicDataAtomFamily,
} from '../subscription/subscriptionAtoms';
import { setDebugLabels } from '../utils/atomUtils';
import { parsePayloadToMessage } from '../utils/messageUtils';

export const handleMqttMessageAtom = atom(
  null,
  async (get, set, { topic, payload }: { topic: string; payload: Buffer }) => {
    const activeTopics = get(activeTopicsAtom);
    if (!activeTopics.has(topic)) {
      return;
    }

    try {
      const config = get(subscriptionConfigAtomFamily(topic));
      const message = await parsePayloadToMessage(topic, payload, config);
      set(topicDataAtomFamily(topic), message);
    } catch (error) {
      const errorMessage = createErrorMessage(topic, error);
      set(topicDataAtomFamily(topic), errorMessage);
    }
  },
);

setDebugLabels({
  handleMqttMessage: handleMqttMessageAtom,
});
